import { LOCATION_UPDATED_EVENT_NAME, UPDATED_SHOP_DATA_EVENT, CART_COUNT_UPDATED_EVENT_NAME } from '@nike/custom-event-names';
import getCartQueryKey from '@nike/shop-apis/buy/carts/v2/get-query-key';
import getFetchIdentityUserAddressOptions from '@nike/shop-apis/identity/user/v1/address/get-options';
import { selectPreferredAddress } from '@nike/shop-apis/identity/user/v1/address/select';
import deriveUrlWithFragment from '@nike/shop-apis/utils/derive-url-with-fragment';
import getList from './utils/get-list';
var LISTS_INITIALIZED_EVENT_NAME = '@nikeShopEvents/listsInitialized';
var EMPTY_CART = Object.freeze({});

/**
 * @memberof NikeShop
 * @name NikeShop.get
 * @returns {NikeShopAccessors} - properties available on object returned by NikeShop.get for consumers of nike-shop-client to use
 *
 * @example <caption>Using accessors for supported values</caption>
 * const cartCount = NikeShop.get().totalCartQuantity;
 * const cartHref = NikeShop.get().cartHref;
 *
 * @example <caption>Using event listeners and preferred pickup location</caption>
 * window.addEventListener(NikeShop.get().events.locationUpdated, ({ detail }) => {
 *   const { postalCode, locationId } = detail;
 *   if(locationId) {
 *     const storeName = NikeShop.get().preferredPickupLocation.name
 *     ...
 *    }
 * });
 */
export default function get() {
  var _window$NikeShop$__IN = window.NikeShop.__INTERNAL_USE__,
    queryClient = _window$NikeShop$__IN.queryClient,
    stores = _window$NikeShop$__IN.stores;
  return Object.defineProperties({}, {
    postalCode: {
      get: function get() {
        var _stores$retailMFE, _selectPreferredAddre;
        var retailMFEPostalCode = stores === null || stores === void 0 || (_stores$retailMFE = stores.retailMFE) === null || _stores$retailMFE === void 0 || (_stores$retailMFE = _stores$retailMFE.store) === null || _stores$retailMFE === void 0 || (_stores$retailMFE = _stores$retailMFE.getState()) === null || _stores$retailMFE === void 0 || (_stores$retailMFE = _stores$retailMFE.locationSearch) === null || _stores$retailMFE === void 0 ? void 0 : _stores$retailMFE.postCode;
        var identityAddresses = queryClient.getQueryData(getFetchIdentityUserAddressOptions().queryKey);
        var identityPostalCode = (_selectPreferredAddre = selectPreferredAddress(identityAddresses)) === null || _selectPreferredAddre === void 0 ? void 0 : _selectPreferredAddre.code;
        return retailMFEPostalCode || identityPostalCode || '';
      },
      configurable: true,
      enumerable: true
    },
    list: {
      get: function get() {
        return getList({
          queryClient: queryClient
        });
      },
      configurable: true,
      enumerable: true
    },
    cartHref: {
      get: function get() {
        return deriveUrlWithFragment('cart');
      },
      configurable: true,
      enumerable: true
    },
    favoritesHref: {
      get: function get() {
        return deriveUrlWithFragment('favorites');
      },
      configurable: true,
      enumerable: true
    },
    checkoutHref: {
      get: function get() {
        return deriveUrlWithFragment('checkout');
      },
      configurable: true,
      enumerable: true
    },
    cart: {
      get: function get() {
        var _queryClient$getQuery;
        // Type-safety fallback for guests/no-cart state so nested reads like NikeShop.get().cart.id do not throw.
        return (_queryClient$getQuery = queryClient.getQueryData(getCartQueryKey())) !== null && _queryClient$getQuery !== void 0 ? _queryClient$getQuery : EMPTY_CART;
      },
      configurable: true,
      enumerable: true
    },
    events: {
      get: function get() {
        return {
          locationUpdated: LOCATION_UPDATED_EVENT_NAME,
          sharedDataUpdated: UPDATED_SHOP_DATA_EVENT,
          cartCountUpdated: CART_COUNT_UPDATED_EVENT_NAME,
          listsInitialized: LISTS_INITIALIZED_EVENT_NAME
        };
      },
      configurable: true,
      enumerable: true
    }
  });
}